import loadable from "@loadable/component"
import PropTypes from "prop-types"

import { retry } from "helpers/application"

const FeaturedGifts = loadable(() => retry(() => import("./featured-gifts")))
const JewelrySlideshow = loadable(() =>
  retry(() => import("./jewelry-slideshow"))
)
const ValuesSetInStone = loadable(() =>
  retry(() => import("./values-set-in-stone"))
)

const LandingCodeRef = ({ element }) => {
  const { ref } = element.data || {}

  if (!ref) return null

  switch (ref) {
    case "jewelry-slideshow":
      return <JewelrySlideshow element={element} />
    case "featured-gifts":
      return <FeaturedGifts />
    case "values-set-in-stone":
      return <ValuesSetInStone />
    default:
      return null
  }
}

LandingCodeRef.propTypes = {
  element: PropTypes.object,
}

export default LandingCodeRef
